import React, { useState } from "react";
import FooterButton from "../FooterButton";
import Checkbox from "components/BaseWidgets/checkbox";
import "./style.scss";
import { checkBoxLabel } from "./helper";
import ReasonBox from "./components/ReasonBox";
import ActionModal from "../ActionModal";
import { retrieveToken } from "utils/storage";
import { DeleteIconCircle } from "assets/icons";
import OtpModal from "./components/OtpModal";
import { useDeleteAccount, useSendOtp } from "hooks/api/useSettings";

function DeleteAccount({ data, setOpen }) {
  const updatedMobile = retrieveToken("updatedMobile");

  const updatedMail = localStorage.getItem("user");
  const parsedMail = updatedMail ? JSON.parse(updatedMail) : null;

  const [deleteModal, setDeleteModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [checked, setChecked] = useState(false);

  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [reasonText, setReasonText] = useState("");
  const [error, setError] = useState("");

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  const { mutate: deleteAccount, isLoading: dltLoading } = useDeleteAccount({
    onSuccess: () => {},
  });

  const { mutate: sendOtp } = useSendOtp({
    onSuccess: () => {
      setOtpModal(true);
    },
  });

  const handleSave = () => {
    setError("");

    if (!selectedReason) {
      setError("Please select a reason before proceeding.");
      return;
    }
    if (!checked) {
      setError("Please confirm by checking the box.");
      return;
    }

    const payload = {
      reason: selectedReason,
      details: reasonText,
    };

    setDeleteModal(true);
  };

  return (
    <>
      <div className="tab-content security-privacy-tab">
        <h1 className="tab-title">
          Are you sure you want to delete your account?
        </h1>

        <ReasonBox
          value={selectedReason}
          onChange={(item) => {
            setSelectedReason(item.value);
            setSelectedLabel(item.label);
          }}
          textValue={reasonText}
          onTextChange={setReasonText}
        />

        <Checkbox
          className="settings-checkbox"
          isChecked={checked}
          onChange={handleCheckboxChange}
        >
          {checkBoxLabel}
        </Checkbox>

        {error && <p className="error-text">{error}</p>}

        <FooterButton
          secondaryBtn={selectedLabel === "I found a match"}
          onCancel={() => setOpen(true)}
          onSave={handleSave}
          secondaryLabel="Add your success story"
          primaryLabel="Delete"
        />
      </div>

      <ActionModal
        title="Delete your account?"
        description="
          Deleting your account is permanent and will remove all your data. Please verify with OTP to confirm your request.
        "
        open={deleteModal}
        setOpen={setDeleteModal}
        footer={{
          left: { label: "Cancel", action: () => setDeleteModal(false) },
          right: {
            label: "Send OTP",
            action: () => {
              const identifier =
                parsedMail?.email ||
                data?.email ||
                parsedMail?.phone ||
                data?.phone ||
                null;
              const otpPayload = { identifier,is_delete_account: true };
              sendOtp(otpPayload);
              setDeleteModal(false);
              setOtpModal(true);
            },
          },
        }}
        icon={<DeleteIconCircle />}
      />

      <OtpModal
        open={otpModal}
        setOpen={setOtpModal}
        identifier={parsedMail?.email || parsedMail?.phone}
        deletePayload={{ reason: selectedReason, details: reasonText }}
        onDelete={deleteAccount}
      />
    </>
  );
}

export default DeleteAccount;
